import { render, staticRenderFns } from "./billFooter.vue?vue&type=template&id=6c865d65&"
import script from "./billFooter.vue?vue&type=script&lang=js&"
export * from "./billFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports